<template v-if="task_template">
  <div class="container-fluid">
    <b-row class="admin-page">
      <div class="col-md-8">
        <b-modal
        centered
        id="task-template"
        @hidden="clearItem"
        hide-footer
        class="mx-auto px-auto"
        >
        <b-form class="admin-form" @submit.stop.prevent="submitTaskTemplate">
          <b-form-group horizontal label="Task">
            <b-form-input type="text" v-model="taskTemplateObject.text"></b-form-input>
          </b-form-group>
          <b-form-group horizontal label="Notes">
            <b-form-input type="text" v-model="taskTemplateObject.team_notes"></b-form-input>
          </b-form-group>
          <b-form-group horizontal label="Priority">
            <b-form-select type="" v-model="taskTemplateObject.priority" :options="priorities"></b-form-select>
          </b-form-group>
          <b-form-group horizontal label="Create One Per Client">
            <b-form-checkbox type="text" v-model="taskTemplateObject.create_per_client"></b-form-checkbox>
          </b-form-group>
          <b-form-group horizontal label="Task Value">
            <b-form-select type="number" v-model="taskTemplateObject.value" :options="[1,2,3,4,5,6,7,8,9,10]"></b-form-select>
          </b-form-group>
          <b-form-group horizontal label="Documentation Link">
            <b-form-input type="text" v-model="taskTemplateObject.documentation_link"></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">Submit</b-button>
        </b-form>
        </b-modal>
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'TaskTemplate',
  props: ['task_template', 'task_template_collection'],
  data () {
    return {
      priorities: [
        { text: 'low', value: 'low' },
        { text: 'medium', value: 'medium' },
        { text: 'high', value: 'high' }
      ],
      taskTemplateObject: {}
    }
  },
  watch: {
    task_template: function (val) {
      this.setTaskTemplate()
    }
  },
  methods: {
    setTaskTemplate () {
      if (this.task_template) {
        this.taskTemplateObject = this.task_template
      }
    },
    submitSuccessful () {
      this.$parent.updateTasksOrder()
      this.$root.$emit('taskTemplateWasAdded', this.task_template_collection.id)
    },
    submitTaskTemplate () {
      var vm = this
      if (this.taskTemplateObject.hasOwnProperty('id')) {
        this.$http.put(
          ('task_template_collections/' + this.task_template_collection.id + '/task_templates/' + this.taskTemplateObject.id), {task_template: this.taskTemplateObject})
          .then(response => vm.submitSuccessful(response))
          .catch(e => { console.log(e.response) })
      } else {
        this.$http.post(
          ('/task_template_collections/' + this.task_template_collection.id + '/task_templates'), {task_template: this.taskTemplateObject})
          .then(response => vm.submitSuccessful(response))
          .catch(e => { console.log(e.response) })
      }
      this.clearItem()
    },
    clearItem () {
      this.$root.$emit('resetItemSelect')
    }
  }
}
</script>

<style scoped>
.custom-control.custom-checkbox.custom-control-inline {
  float: left;
}
</style>

<style>
  #task-template .modal-dialog {
    max-width: 700px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/TaskTemplate.vue